import { useState, useEffect, useRef } from "react";
import BuyPlan from "../page/PlanPurchase/BuyPlan";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";


const IMG = {
  doctorPortrait:
    "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=900&q=80&auto=format&fit=crop",
  familyIndian: "assets/images/a1.jpg",
  consultation: "assets/images/a0.jpg",
  labTest:
    "https://images.pexels.com/photos/4226219/pexels-photo-4226219.jpeg?auto=compress&cs=tinysrgb&w=900",
  telehealth:
    "https://images.pexels.com/photos/8376277/pexels-photo-8376277.jpeg?auto=compress&cs=tinysrgb&w=900",
  medicine:
    "https://images.pexels.com/photos/4386466/pexels-photo-4386466.jpeg?auto=compress&cs=tinysrgb&w=900",
  elderly:
    "https://images.pexels.com/photos/7551617/pexels-photo-7551617.jpeg?auto=compress&cs=tinysrgb&w=900",
  wellness:
    "https://images.pexels.com/photos/3823495/pexels-photo-3823495.jpeg?auto=compress&cs=tinysrgb&w=900",
};

const partners = [
  "Tata 1mg",
  "HealthKart",
  "BeatO",
  "Toothai",
  "Manipal Hospitals",
  "PharmEasy",
];

const benefits = [
  {
    img: IMG.medicine,
    title: "Savings on Daily Healthcare",
    desc: "Save up to 50% on doctor consultations, diagnostics, and medicines with your Sugmya Finance membership.",
  },
  {
    img: IMG.telehealth,
    title: "Zero Waiting Periods",
    desc: "Benefits start from Day 1. No complicated claim forms, no waiting — just instant access to healthcare.",
  },
  {
    img: IMG.consultation,
    title: "Seamless No-Claims Experience",
    desc: "Say goodbye to paperwork. Use your digital app and walk out — no bills to fight, no claims to file.",
  },
  {
    img: IMG.labTest,
    title: "Pan-India Network of Specialists",
    desc: "500+ clinics and diagnostic centres across India. 17+ specialties, always just a few minutes away.",
  },
  {
    img: IMG.elderly,
    title: "360° Primary Care Ecosystem",
    desc: "One membership for doctor visits, medicines, lab tests, mental wellness, dental, and preventive care.",
  },
  {
    img: IMG.wellness,
    title: "Focus on Preventive Wellness",
    desc: "Regular health check-ups and wellness sessions to keep you healthy before illness strikes.",
  },
];

const steps = [
  {
    num: "01",
    img: IMG.familyIndian,
    title: "Choose Your Plan",
    desc: "Pick the plan that fits — for yourself, your couple, or your entire family including parents and children.",
  },
  {
    num: "02",
    img: IMG.telehealth,
    title: "Instant Activation",
    desc: "Complete registration via phone or email. Your benefits activate the moment you sign up — no delays.",
  },
  {
    num: "03",
    img: IMG.consultation,
    title: "Book with Ease",
    desc: "Use the portal or app to find a doctor, book a diagnostic test, or order medicines in just a few clicks.",
  },
];

const plans = [
  {
    name: "Sugmya Saral",
    planCode: "SugmyaSaral",
    memberCount: 0,
    tag: "Member Coverage: Individual",
    tagColor: "#0657A3",
    tagBg: "#e8f0fb",
    price: 199,
    members: "1 Adult",
    ageRange: "18–85 yrs",
    note: "This Plan applicable for the age from 18 - 85 years",
    sections: [
      {
        label: null,
        items: [
          "20 Credits on Tele Doctor Consultation: GP",
          "4 Credits on Tele Consultation (24+ Specialist)",
          "1 Credit on Health Check-up (Home Sample Collection)",
          "Up to 50% Discounted on Diagnostics Test and Packages",
          "4 Credits on Dental In-Clinic Consultation",
          "Unlimited Eye In-Clinic Consultations",
          "Discounted Diabetes Membership"
        ],
      },
      
      {
        label: "Inclusive Benefits",
        items: [
          "Chat with Experts",
           "Health Reminder", 
           "Unlimited Health Risk Assessment",
          "Recorded Fitness Sessions",
          "24*7 Customer Support",
        ],
      },
      {
        label: "Platform Benefits",
        items: [
          "Covered Upto 20% discount on Prescribed Pharmacy",
          "Covered Upto 30% discount on Gym Membership"
        ],
      },
    ],
  },
  {
    name: "Sugmya Sahaj",
    planCode: "SugmyaSahaj",
    memberCount: 0,
    tag: "Member Coverage: Individual",
    tagColor: "#085041", tagBg: "#e1f5ee",
    price: 499,
    members: "1 Adult",
    ageRange: "18–85 yrs",
    note: "This Plan applicable for the age from 18 - 85 years",
    sections: [
      {
        label: null,
        items: [
          "30 Credits on Tele Doctor Consultation: GP",
          "6 Credits on Tele Consultation (24+ Specialist)",
          "1 Credit on Health Check-up (Home Sample Collection)",
          "Up to 50% Discounted on Diagnostics Test and Packages",
          "Unlimited Credits on Dental In-Clinic Consultation",
          "Unlimited Eye In-Clinic Consultations",
          "Discounted Diabetes Membership",
          "6 Credits on Mental Wellness Counselling"
        ],
      },
      
      {
        label: "Inclusive Benefits",
        items: [
          "Chat with Experts",
           "Health Reminder", 
           "Unlimited Health Risk Assessment",
          "Recorded Fitness Sessions",
          "Health Vault (ABHA Card)",
          "24*7 Customer Support",
        ],
      },
      {
        label: "Platform Benefits",
        items: [
          "Covered Upto 20% discount on Prescribed Pharmacy",
          "Covered Upto 30% discount on Gym Membership"
        ],
      },
    ],
  },
  {
    name: "Sugmya Sampoorna",
    planCode: "SugmyaSampoorna",
    memberCount: 0,
    tag: "Member Coverage: Individual",
    tagColor: "#633806", tagBg: "#faeeda",
    price: 749,
    members: "1 Adult",
    ageRange: "18–85 yrs",
    note: "This Plan applicable for the age from 18 - 85 years",
    sections: [
      {
        label: null,
        items: [
          "35 Credits on Tele Doctor Consultation: GP",
          "6 Credits on Tele Consultation (24+ Specialist)",
          "1 Credit on Health Check-up (Home Sample Collection)",
          "Up to 50% Discounted on Diagnostics Test and Packages",
          "Unlimited Credits on Dental In-Clinic Consultation",
          "Unlimited Eye In-Clinic Consultations",
          "Discounted Diabetes Membership",
          "8 Credits on Mental Wellness Counselling"
        ],
      },
      
      {
        label: "Inclusive Benefits",
        items: [
          "Chat with Experts",
           "Health Reminder", 
           "Unlimited Health Risk Assessment",
          "Recorded Fitness Sessions",
          "Health Vault (ABHA Card)",
          "24*7 Customer Support",
        ],
      },
      {
        label: "Platform Benefits",
        items: [
          "Covered Upto 20% discount on Prescribed Pharmacy",
          "Covered Upto 30% discount on Gym Membership"
        ],
      },
    ],
  },
  {
    name: "Sugmya Samarth",
    planCode: "SugmyaSamarth",
    memberCount: 0,
    tag: "Member Coverage: Individual",
    tagColor: "#3C3489", tagBg: "#eeedfe",
    price: 999,
    members: "1 Adult",
    ageRange: "18–85 yrs",
    note: "This Plan applicable for the age from 18 - 85 years",
    sections: [
      {
        label: null,
        items: [
          "Unlimited Credits on Tele Doctor Consultation: GP",
          "8 Credits on Tele Consultation (24+ Specialist)",
          "1 Credit on Health Check-up (Home Sample Collection)",
          "Up to 50% Discounted on Diagnostics Test and Packages",
          "Unlimited Credits on Dental In-Clinic Consultation",
          "Unlimited Eye In-Clinic Consultations",
          "Discounted Diabetes Membership",
          "10 Credits on Mental Wellness Counselling"
        ],
      },
      
      {
        label: "Inclusive Benefits",
        items: [
          "Chat with Experts",
           "Health Reminder", 
           "Unlimited Health Risk Assessment",
          "Recorded Fitness Sessions",
          "Health Vault (ABHA Card)",
          "24*7 Customer Support",
        ],
      },
      {
        label: "Platform Benefits",
        items: [
          "Covered Upto 20% discount on Prescribed Pharmacy",
          "Covered Upto 30% discount on Gym Membership"
        ],
      },
    ],
  },
];

const testimonials = [
  {
    name: "Vikram Singh",
    city: "Gurugram",
    stars: 5,
    text: "The approval process was fast, straightforward, and completely hassle-free. Sugmya Finance provided the funding I needed right when it mattered most.",
  },
  {
    name: "Priya Malhotra",
    city: "Noida",
    stars: 5,
    text: "Exceptional customer service and complete transparency. The team explained every detail clearly and helped me choose the right financing solution for my needs.",
  },
  {
    name: "Amit Verma",
    city: "Jaipur",
    stars: 5,
    text: "From application to disbursement, everything was handled professionally. Sugmya Finance earned my trust through their quick response time and customer-first approach.",
  },
];

/* ── Intersection-observer hook ─────────────────────────────────────────── */
const useInView = (threshold = 0.12) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setInView(true);
      },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
};

/* ── Scroll-reveal animation wrapper ───────────────────────────────────── */
const Anim = ({ children, className = "", delay = 0 }) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`h-full transition-all duration-700 ease-out ${
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-7"
      } ${className}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

/* ── Green check icon ───────────────────────────────────────────────────── */
const Check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    className="flex-shrink-0 mt-0.5"
  >
    <circle cx="9" cy="9" r="9" fill="#dcfce7" />
    <path
      d="M5 9l3 3 5-5"
      stroke="#16a34a"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ════════════════════════════════════════════════════════════════════════ */
export default function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showGST, setShowGST] = useState(false);

  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId] = useState("T6611001XT8");
  const [isRider, setIsRider] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [memberCount, setMemberCount] = useState(0);

  const handleBuyPlan = (plan) => {
    setPlanCode(plan.planCode);
    setOpenPopup(true);
    setIsRider(false);
    setMemberCount(plan.memberCount);
    setShowMember(false);
  };

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className="font-[DM_Sans,Segoe_UI,sans-serif] text-[#1a1a2e] bg-white overflow-x-hidden">

      {/* ── Google Fonts + global keyframes ─────────────────────────────── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&family=Sora:wght@600;700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        html{scroll-behavior:smooth}
        body{overflow-x:hidden}
        @keyframes fadeUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
        @keyframes pulse-ring{0%,100%{box-shadow:0 0 0 0 rgba(156,203,61,.4)}70%{box-shadow:0 0 0 10px rgba(156,203,61,0)}}
        .animate-fadeUp{animation:fadeUp .85s ease both}
        .animate-pulse-ring{animation:pulse-ring 2s infinite}
        ::-webkit-scrollbar{width:5px}
        ::-webkit-scrollbar-track{background:#f0f0f0}
        ::-webkit-scrollbar-thumb{background:#0E92CC;border-radius:3px}
      `}</style>

      {/* ── NAVBAR ────────────────────────────────────────────────────────── */}
      

      {/* ── HERO ──────────────────────────────────────────────────────────── */}
      <section
        id="home"
        className="min-h-screen relative overflow-hidden flex items-center justify-center px-[5%] pt-[120px] pb-20"
      >
        {/* Background image */}
        <img
          src="assets/images/bg-sugmaya.jpg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-fit"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/35 via-[rgba(241,62,21,0.65)] to-[rgba(2,38,100,0.89)]" />
        {/* Dot pattern */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "radial-gradient(circle,#fff 1px,transparent 1px)",
            backgroundSize: "36px 36px",
          }}
        />

        {/* Hero content */}
        <div className="relative max-w-[820px] w-full text-center animate-fadeUp">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white backdrop-blur-md rounded-full px-[18px] py-[7px] mb-7 border border-[#023365]">
            <span className="w-2 h-2 rounded-full bg-[#023365] inline-block animate-pulse-ring" />
            <span className="text-[#023365] text-[13px] font-bold tracking-wide">
              Welcome to Sugmya Finance
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-[Sora,sans-serif] text-[clamp(38px,6.5vw,72px)] font-extrabold text-white leading-[1.06] mb-6">
            Where Hospital Care Ends,{" "}
            <span className="text-[#023365]">We Begin</span>
          </h1>

          {/* Subheadline */}
          <p className="text-white/85 text-[clamp(16px,2vw,19px)] leading-[1.72] max-w-[580px] mx-auto mb-10">
            Save up to 50% on doctor consultations, lab tests, and medicines.
            <br />
            No waiting periods. Benefits start from Day 1.
          </p>

          {/* CTA buttons */}
          <div className="flex gap-3.5 justify-center flex-wrap mb-15">
            <button
              onClick={() => scrollTo("plans")}
              className="bg-gradient-to-l from-[#CC0404] via-[#5B1E3A] to-[#023365] text-white border-none py-[15px] px-10 rounded-full text-base font-semibold cursor-pointer  transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5"
            >
              Explore Plans →
            </button>
            <button
              onClick={() => scrollTo("benefits")}
              className="bg-transparent border-2 border-white/50 text-white py-[13px] px-7 rounded-full text-base font-semibold cursor-pointer  transition-all duration-200 hover:bg-white/10"
            >
              Learn More
            </button>
          </div>

          {/* Stats bar */}
          <div className="flex flex-wrap justify-center bg-blue-900/10 backdrop-blur-md rounded-[50px] border border-white/15 overflow-hidden mt-14">
            {[
              ["500+", "Partner Clinics"],
              ["50%", "Savings on OPD"],
              ["Day 1", "Instant Benefits"],
              ["4 Lakh+", "Happy Members"],
            ].map(([v, l], i, arr) => (
              <div
                key={l}
                className={`flex-1 min-w-[120px] px-6 py-5 text-center ${
                  i < arr.length - 1 ? "border-r border-white/10" : ""
                }`}
              >
                <div className="font-[Sora,sans-serif] text-[clamp(20px,3vw,28px)] font-extrabold text-white">
                  {v}
                </div>
                <div className="text-white text-base mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PARTNERS STRIP ────────────────────────────────────────────────── */}
      <section className="py-[22px] px-[5%] bg-[#f8faff] border-b border-[#eef2f8] mt-11">
        <div className="max-w-[1200px] mx-auto flex items-center gap-7 flex-wrap justify-center">
          <span className="text-xs text-[#CC0404] font-semibold tracking-widest uppercase">
            Trusted partners
          </span>
          <Swiper
              modules={[Autoplay]}
              slidesPerView={2}
              spaceBetween={30}
              loop={true}
              speed={3000}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 4,
                },
                1024: {
                  slidesPerView: 6,
                },
              }}
              className=""
            >
              {[
                "/assets/images/partner_logo/1.svg",
                "/assets/images/partner_logo/2.svg",
                "/assets/images/partner_logo/4.svg",
                "/assets/images/partner_logo/5.svg",
                "/assets/images/partner_logo/6.svg",
                "/assets/images/partner_logo/7.svg",
                "/assets/images/partner_logo/8.svg",
                "/assets/images/partner_logo/9.png",
                "/assets/images/partner_logo/10.png",
                "/assets/images/partner_logo/11.png",
                "/assets/images/partner_logo/12.png",
                "/assets/images/partner_logo/13.svg",
                "/assets/images/partner_logo/14.png",
              ].map((logo, index) => (
                <SwiperSlide key={index}>
                  <div className="flex items-center justify-center h-[100px]">
                    <img
                      src={logo}
                      alt={`Partner ${index + 1}`}
                      className="max-h-[60px] w-auto object-contain hover:grayscale-0 transition-all duration-300"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
        </div>
      </section>

      {/* ── ABOUT / PHILOSOPHY ────────────────────────────────────────────── */}
      <section className="py-20 px-[5%] bg-white">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          {/* Image mosaic */}
          <Anim className="!h-auto">
            <div className="relative h-[480px]">
              <div className="absolute top-0 left-0 w-[64%] h-[70%] rounded-[20px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
                <img
                  src={IMG.consultation}
                  alt="Doctor consulting patient"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-0 right-0 w-[58%] h-[62%] rounded-[20px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
                <img
                  src={IMG.familyIndian}
                  alt="Indian family"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-[52px] -left-3 bg-white rounded-2xl px-[18px] py-3.5 shadow-[0_8px_32px_rgba(0,0,0,0.1)] border border-[#eef2f8] z-10">
                <div className="font-[Sora,sans-serif] font-extrabold text-[22px] text-[#0657A3]">
                  4 Lakh+
                </div>
                <div className="text-xs text-[#5a6a80] mt-0.5">
                  Happy Families
                </div>
              </div>
            </div>
          </Anim>

          {/* Text */}
          <Anim delay={0.15} className="!h-auto">
            <div className="text-xs font-semibold tracking-[.12em] uppercase text-[#CC0404] mb-2.5">
  Our Philosophy
</div>

<h2 className="font-[Sora,sans-serif] text-[clamp(26px,4vw,42px)] font-extrabold leading-[1.18] text-[#0b1e40]">
  The Foundation of
  <span className="text-[#CC0404] ml-2">Sugmya Finance</span>
</h2>

<p className="text-[17px] text-[#5a6a80] leading-[1.72] mt-3">
  We believe financial support should be accessible, transparent, and
  empowering. Sugmya Finance was founded with a mission to help individuals,
  families, and businesses achieve their goals through reliable and affordable
  financial solutions.
</p>

<p className="text-[15px] text-[#5a6a80] leading-[1.75] mt-3.5">
  Whether it's funding a business expansion, managing personal financial
  needs, or supporting long-term growth, we are committed to providing quick
  approvals, flexible repayment options, and exceptional customer service.
  Our focus is to make finance simple, trustworthy, and within reach for
  everyone.
</p>
            <div className="grid grid-cols-2 gap-3.5 mt-7">
              {[
                ["🤝", "Network", "500+ clinics & diagnostic centres"],
                [
                  "💡",
                  "Transparency",
                  "No hidden charges or complicated claims",
                ],
                [
                  "❤️",
                  "Support",
                  "Dedicated health manager for every member",
                ],
                [
                  "🌱",
                  "Prevention",
                  "Proactive wellness — not just reactive care",
                ],
              ].map(([icon, title, desc]) => (
                <div
                  key={title}
                  className="bg-[#f8faff] rounded-2xl p-4 border border-[#eef2f8]"
                >
                  <div className="text-[22px] mb-1.5">{icon}</div>
                  <div className="font-semibold text-sm text-[#0b1e40] mb-1">
                    {title}
                  </div>
                  <div className="text-[13px] text-[#5a6a80] leading-[1.55]">
                    {desc}
                  </div>
                </div>
              ))}
            </div>
          </Anim>
        </div>
      </section>

      {/* ── BENEFITS ──────────────────────────────────────────────────────── */}
      <section id="benefits" className="py-20 px-[5%] bg-[#f8faff]">
        <div className="max-w-[1200px] mx-auto">
          <Anim className="text-center mb-12 !h-auto">
            <div className="text-xs font-semibold tracking-[.12em] uppercase text-[#CC0404] mb-2.5">
              Our Benefits
            </div>
            
            <h2 className="font-[Sora,sans-serif] text-[clamp(26px,4vw,42px)] inline-flex items-center gap-2 font-extrabold leading-[1.18] text-[#0b1e40]">
  <span>Why Choose </span>
  <span className="text-[#CC0404]">Sugmya Finance</span>
</h2>
            <p className="text-[17px] text-[#5a6a80] leading-[1.72] mt-3 max-w-[540px] mx-auto">
              Everything you need for everyday healthcare — in one affordable
              membership.
            </p>
          </Anim>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {benefits.map((b, i) => (
              <Anim key={i} delay={i * 0.07}>
                <div className="bg-white rounded-[20px] overflow-hidden border border-[#eef2f8] h-full cursor-pointer transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_56px_rgba(6,87,163,0.11)] group">
                  <div className="h-[190px] overflow-hidden">
                    <img
                      src={b.img}
                      alt={b.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="px-[22px] pt-5 pb-[26px]">
                    <div className="font-[Sora,sans-serif] text-[17px] font-bold text-[#0b1e40] mb-2">
                      {b.title}
                    </div>
                    <p className="text-[#5a6a80] text-sm leading-[1.72]">
                      {b.desc}
                    </p>
                  </div>
                </div>
              </Anim>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ──────────────────────────────────────────────────── */}
      <section className="py-20 px-[5%] bg-white">
        <div className="max-w-[1200px] mx-auto">
          <Anim className="text-center mb-14 !h-auto">
            <div className="text-xs font-semibold tracking-[.12em] uppercase text-[#CC0404] mb-2.5">
              How It Works
            </div>
            
            <h2 className="font-[Sora,sans-serif] text-[clamp(26px,4vw,42px)] inline-flex items-center gap-2 font-extrabold leading-[1.18] text-[#0b1e40]">
  <span>Your Path to </span>
  <span className="text-[#CC0404]">Hassle-Free Health</span>
</h2>
            <p className="text-[17px] text-[#5a6a80] leading-[1.72] mt-3">
              Get started in 3 simple steps — no paperwork, no delays.
            </p>
          </Anim>

          <div className="flex flex-col gap-16">
            {steps.map((s, i) => (
              <Anim key={i} delay={0.1} className="!h-auto">
                <div
                  className={`grid grid-cols-1 md:grid-cols-2 gap-[52px] items-center ${
                    i % 2 !== 0 ? "md:[direction:rtl]" : ""
                  }`}
                >
                  <div className="rounded-3xl overflow-hidden aspect-video shadow-[0_24px_72px_rgba(0,0,0,0.1)] md:[direction:ltr]">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="md:[direction:ltr]">
                    <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-l from-[#CC0404] via-[#7A1B36] to-[#023365] shadow-[0_8px_24px_rgba(6,87,163,0.3)] mb-5">
                      <span className="font-[Sora,sans-serif] text-white text-[18px] font-extrabold">
                        {s.num}
                      </span>
                    </div>
                    <h3 className="font-[Sora,sans-serif] text-[clamp(22px,3vw,30px)] font-extrabold text-[#0b1e40] mb-3.5">
                      {s.title}
                    </h3>
                    <p className="text-[#5a6a80] text-[17px] leading-[1.78]">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </Anim>
            ))}
          </div>
        </div>
      </section>

      {/* ── PLANS ─────────────────────────────────────────────────────────── */}
      <section id="plans" className="py-20 px-[5%] bg-[#f8faff]">
        <div className="max-w-[1350px] mx-auto">
          <Anim className="text-center mb-11 !h-auto">
            <div className="text-xs font-semibold tracking-[.12em] uppercase text-[#CC0404] mb-2.5">
              Pricing
            </div>
            
            <h2 className="font-[Sora,sans-serif] text-[clamp(26px,4vw,42px)] inline-flex items-center gap-2 font-extrabold leading-[1.18] text-[#0b1e40]">
  <span>Choose the</span>
  <span className="text-[#CC0404]">Right</span>
  <span>Plan</span>
</h2>
            <p className="text-[17px] text-[#5a6a80] leading-[1.72] mt-3">
              Transparent pricing. No hidden costs. GST shown clearly.
            </p>

            
          </Anim>

          {/* Plan cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 items-stretch">
            {plans.map((plan, i) => (
              <Anim key={i} delay={i * 0.08}>
                <div className="border border-[#e0eaf5] rounded-[20px] overflow-hidden bg-white shadow-[0_2px_16px_rgba(0,0,0,0.05)] transition-all duration-200 h-full flex flex-col hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(6,87,163,0.1)]">

                  {/* Card top */}
                  <div className="px-5 pt-[22px] pb-1.5 flex-shrink-0">
                    <div className=" text-[18px] font-extrabold text-[#0b1e40] mb-2 inline-flex">
                      {plan.name}
                    </div>
                    <span
                      className="inline-block text-xs font-semibold px-3 py-1 rounded-full mb-4"
                      style={{ background: plan.tagBg, color: plan.tagColor }}
                    >
                      {plan.tag}
                    </span>
                    <div className="mb-4">
                      <span className="font-[Sora,sans-serif] text-[38px] font-extrabold text-[#0b1e40]">
                        ₹
                        {(showGST ? plan.priceGST : plan.price).toLocaleString()}
                      </span>
                      <span className="text-[13px] text-[#8a9ab0] ml-1">
                        {showGST ? " (incl.)" : ""}
                      </span>
                    </div>
                  </div>

                  <hr className="border-t border-[#eef2f8] mx-5" />

                  {/* Card bottom */}
                  <div className="px-5 pt-1 pb-5 flex-1 flex flex-col">
                    <div className="flex-1">
                      {plan.sections.map((sec, si) => (
                        <div key={si}>
                          {sec.label && (
                            <>
                              <hr className="border-t border-[#eef2f8] my-2.5" />
                              <div className="text-xs font-bold text-[#0b1e40] mt-3 mb-0.5 tracking-[0.01em]">
                                {sec.label}
                              </div>
                              {sec.sublabel && (
                                <span className="text-[11px] text-[#8a9ab0] block mb-1.5">
                                  {sec.sublabel}
                                </span>
                              )}
                            </>
                          )}
                          {sec.items.map((item, ii) => (
                            <div
                              key={ii}
                              className="flex gap-2 items-start mb-[7px]"
                            >
                              <Check />
                              <span className="text-[13px] text-[#2d3e50] leading-[1.45]">
                                {item}
                              </span>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>

                    <p className="text-[11px] text-[#8a9ab0] mt-4 leading-relaxed italic">
                      *Note: {plan.note}
                    </p>

                    <button
                      className="w-full mt-3.5 py-[13px] rounded-full text-sm font-semibold  border-none cursor-pointer transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5 bg-gradient-to-l from-[#CC0404] via-[#5B1E3A] to-[#023365] text-white"
                      onClick={() => handleBuyPlan(plan)}
                    >
                      Buy Plan ↗
                    </button>
                  </div>
                </div>
              </Anim>
            ))}
          </div>

          
        </div>
      </section>

      {/* ── CTA BANNER ────────────────────────────────────────────────────── */}
      <section className="relative py-[90px] px-[5%] overflow-hidden">
        <img
          src={IMG.elderly}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover object-[center_30%]"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[rgba(108,15,12,0.94)] to-[rgba(6,46,83,0.86)]" />
        <Anim className="max-w-[700px] mx-auto text-center relative !h-auto">
          <h2 className="font-[Sora,sans-serif] text-[clamp(24px,4vw,42px)] font-extrabold text-white mb-4">
            Instant access. Zero waiting.
            <br />
            Day 1 benefits.
          </h2>
          <p className="text-white/75 text-[17px] mb-8">
            Healthcare that doesn't make you wait. Join thousands of families
            who trust Sugmya Finance.
          </p>
          <button
            onClick={() => scrollTo("plans")}
            className="bg-gradient-to-l from-[#CC0404] via-[#5B1E3A] to-[#023365] text-white border-none py-[15px] px-11 rounded-full text-base font-semibold cursor-pointer transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5"
          >
            Get Started Today →
          </button>
        </Anim>
      </section>

      {/* ── TESTIMONIALS ──────────────────────────────────────────────────── */}
      <section id="testimonials" className="py-20 px-[5%] bg-white">
        <div className="max-w-[1200px] mx-auto">
          <Anim className="text-center mb-12 !h-auto">
            <div className="text-xs font-semibold tracking-[.12em] uppercase text-[#CC0404] mb-2.5">
              Testimonials
            </div>
           <h2 className="font-[Sora,sans-serif] text-[clamp(26px,4vw,42px)] inline-flex items-center gap-2 font-extrabold leading-[1.18] text-[#0b1e40]">
  <span>See What Our</span>
  <span className="text-[#CC0404]">Customers</span>
  <span>Have to Say</span>
</h2>
          </Anim>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, i) => (
              <Anim key={i} delay={i * 0.1}>
                <div className="bg-[#f3cece] rounded-[20px] p-7 border border-[#eef2f8] h-full flex flex-col">
                  <div className="flex gap-1 mb-4">
                    {Array(t.stars)
                      .fill(0)
                      .map((_, si) => (
                        <span key={si} className="text-amber-800 text-xl">
                          ★
                        </span>
                      ))}
                  </div>
                  <p className="text-[#2d3e50] text-[15px] leading-[1.78] mb-6 italic flex-1">
                    "{t.text}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-[46px] h-[46px] rounded-full bg-gradient-to-l from-[#CC0404] via-[#7A1B36] to-[#023365] flex items-center justify-center text-white text-lg font-bold flex-shrink-0">
                      {t.name[0]}
                    </div>
                    <div>
                      <div className="font-semibold text-[15px] text-[#0b1e40]">
                        {t.name}
                      </div>
                      <div className="text-[13px] text-[#8a9ab0]">{t.city}</div>
                    </div>
                    <div className="ml-auto text-[52px] text-[#0657A3] opacity-10 font-[Georgia,serif] leading-none">
                      "
                    </div>
                  </div>
                </div>
              </Anim>
            ))}
          </div>
        </div>
      </section>

      {/* ── BuyPlan popup ──────────────────────────────────────────────────── */}
      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={showMember}
        memberCount={memberCount}
      />
    </div>
  );
}